import {z} from 'zod';

export type GetMyKanbanSelectedUsersApiResponse = /** status 200  */ SelectedUserBody[];
export type SetMyKanbanSelectedUsersApiResponse = /** status 204  */ void;
export type SetMyKanbanSelectedUsersApiArg = {
  setMyKanbanSelectedUsersRequestBody: SetMyKanbanSelectedUsersRequestBody;
};
export type GetMyKanbanSettingsApiResponse = /** status 200  */ GetMyKanbanSettingsResponseBody;
export type GetMyKanbanSettingsApiArg = {
  kanbanName: string;
};
export type SetMyKanbanSettingsApiResponse = /** status 204  */ void;
export type SetMyKanbanSettingsApiArg = {
  kanbanName: string;
  setMyKanbanSettingsRequestBody: SetMyKanbanSettingsRequestBody;
};
type SelectedUserBody = {
  userId: string;
  isHidden: boolean;
};
export type VisibleColumnsBody = {
  [segment: string]: {
    [columnKey: string]: boolean;
  };
};
export type SetMyKanbanSelectedUsersRequestBody = {
  selectedUsers: SelectedUserBody[];
};
export type KanbanSortBy = z.infer<typeof kanbanSortBySchema>;
export type GetMyKanbanSettingsResponseBody = {
  selectedUsers: SelectedUserBody[];
  visibleColumns: VisibleColumnsBody[];
  sortBy: KanbanSortBy | null;
  branchIds: string[];
};
export type SetMyKanbanSettingsRequestBody = {
  selectedUsers: SelectedUserBody[];
  visibleColumns: VisibleColumnsBody[];
  sortBy?: KanbanSortBy | null;
  branchIds: string[];
};

const selectedUserBodySchema = z.object({
  userId: z.string(),
  isHidden: z.boolean(),
});

export const kanbanSortBySchema = z.enum([
  'CREATED_AT_DESC',
  'CREATED_AT_ASC',
  'LAST_ACTIVITY_ASC',
  'LAST_COMMUNICATION_ASC',
]);

export const setMyKanbanSelectedUsersRequestBodySchema = z.object({
  selectedUsers: z.array(selectedUserBodySchema),
});

export const getMyKanbanSelectedUsersResponseSchema = z.array(selectedUserBodySchema);

export const setMyKanbanSelectedUsersApiArgSchema = z.object({
  setMyKanbanSelectedUsersRequestBody: setMyKanbanSelectedUsersRequestBodySchema,
});

export const getMyKanbanSettingsResponseBodySchema = z.object({
  selectedUsers: z.array(selectedUserBodySchema),
  visibleColumns: z.array(z.record(z.string(), z.record(z.string(), z.boolean()))),
  sortBy: kanbanSortBySchema.nullable(),
  branchIds: z.array(z.string()),
});

export const setMyKanbanSettingsRequestBodySchema = z.object({
  selectedUsers: z.array(selectedUserBodySchema),
  visibleColumns: z.array(z.record(z.string(), z.record(z.string(), z.boolean()))),
  sortBy: kanbanSortBySchema.nullable().optional(),
  branchIds: z.array(z.string()),
});

export const getMyKanbanSettingsApiArgSchema = z.object({
  kanbanName: z.string(),
});

export const setMyKanbanSettingsApiArgSchema = z.object({
  kanbanName: z.string(),
  setMyKanbanSettingsRequestBody: setMyKanbanSettingsRequestBodySchema,
});
